import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/MerchantOfferModal';

export const MERCHANT_OFFER_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const MERCHANT_OFFER_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;
export const MERCHANT_OFFER_MODAL_CLEAR = `${rootActionPath}/CLEAR`;
export const MERCHANT_OFFER_VIEW = `${rootActionPath}/VIEW`;
